import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { PendingVerificationImage } from '@images';

import ContactSupport from '@components/contact-support/ContactSupport';
import {
  Event,
  sendMixpanelEvent,
  trackPageView
} from '@core/analytics/mixpanel';
import Modal from '@layouts/modal/Modal';

const PendingVerification = () => {
  const { currentOrg } = useSelector((state: any) => state.user);

  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);

  const onClickContactSupport = () => {
    setIsSupportModalOpen(true);
    sendMixpanelEvent(Event.CONTACT_SUPPORT_CLICKED, {
      organization_name: currentOrg.name
    });
  };

  useEffect(() => {
    if (currentOrg?.id)
      trackPageView('Pending Verification', {
        organization_name: currentOrg.name
      });
  }, [currentOrg]);

  return (
    <>
      <div className="flex h-[calc(100vh-300px)] flex-col items-center justify-center">
        <div className="flex flex-col items-center">
          <PendingVerificationImage className="h-63 w-57.25" />
          <div className="mt-12 flex text-2xl font-medium text-content">
            Pending Verification
          </div>
          <div className="mt-4 text-base font-normal text-grey">
            We will connect with you as soon as verification is completed.
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center">
        <div className="flex flex-col items-center text-sm font-medium leading-4 text-grey">
          Need help?
          <div className="mb-2 mt-3 font-normal">Talk to our support team</div>
        </div>
        <div
          className="cursor-pointer text-base font-medium text-primary underline"
          onClick={onClickContactSupport}
          role="presentation"
        >
          Contact support
        </div>
      </div>
      {isSupportModalOpen && (
        <Modal
          isOpen={isSupportModalOpen}
          onCancel={() => setIsSupportModalOpen(false)}
          isCloseIconRequired
          className="min-w-325  p-6 "
        >
          <ContactSupport />
        </Modal>
      )}
    </>
  );
};

export default PendingVerification;
